import React, { useState, useEffect } from 'react';

function token() { return localStorage.getItem('token'); }

// apenasClosers: só quem tem cargo com "closer" (Clau, que é IA, fica fora) —
// usado nos campos "closer que vai atender" das oportunidades
export default function SelectColaborador({ value, onChange, placeholder = 'Selecione...', style = {}, apenasClosers = false }) {
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    fetch('/usuarios', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(lista => setUsuarios(lista
        .filter(u => !apenasClosers || ((u.cargo || '').toLowerCase().includes('closer') && u.email !== 'clau@preservamarcas.com.br'))
        .map(u => u.nome).sort()))
      .catch(() => {});
  }, [apenasClosers]);

  return (
    <select
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 14, background: '#fff', ...style }}
    >
      <option value="">{placeholder}</option>
      {usuarios.map(nome => (
        <option key={nome} value={nome}>{nome}</option>
      ))}
    </select>
  );
}
